var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNotesTab = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85156 17.7344H11.1484C12.7656 17.7344 13.5703 16.9141 13.5703 15.2891V8.19531H7.91406C6.91406 8.19531 6.4375 7.71875 6.4375 6.71875V0.984375H2.85156C1.24219 0.984375 0.429688 1.8125 0.429688 3.4375V15.2891C0.429688 16.9219 1.23438 17.7344 2.85156 17.7344ZM7.9375 7.125H13.4766C13.4297 6.80469 13.2031 6.49219 12.8281 6.10938L8.52344 1.72656C8.15625 1.35156 7.83594 1.125 7.50781 1.07031V6.70312C7.50781 6.98438 7.64844 7.125 7.9375 7.125ZM3.9375 11.5938C3.63281 11.5938 3.40625 11.375 3.40625 11.0859C3.40625 10.7969 3.63281 10.5703 3.9375 10.5703H10.0859C10.3828 10.5703 10.6094 10.7969 10.6094 11.0859C10.6094 11.375 10.3828 11.5938 10.0859 11.5938H3.9375ZM3.9375 14.5547C3.63281 14.5547 3.40625 14.3359 3.40625 14.0469C3.40625 13.7578 3.63281 13.5312 3.9375 13.5312H10.0859C10.3828 13.5312 10.6094 13.7578 10.6094 14.0469C10.6094 14.3359 10.3828 14.5547 10.0859 14.5547H3.9375Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNotesTab);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-notes-tab.1cf80ec4cc68cc3dabb88d4a347a1fca.svg";